<!--
  The restricted Markdown subset, rendered with ordinary Angular bindings.

  Every piece of text below reaches the DOM through interpolation, which Angular escapes. There
  is deliberately no [innerHTML] anywhere in this template: if one is ever added here, the
  guarantee that the disclosure cannot inject markup is gone.
-->
<div class="markdown-view">
  @for (block of blocks; track $index) {

    @if (block.kind === 'heading') {
      @switch (block.level) {
        @case (1) { <h1 class="md-heading md-h1"><ng-container *ngTemplateOutlet="runs; context: { $implicit: block.inlines }"></ng-container></h1> }
        @case (2) { <h2 class="md-heading md-h2"><ng-container *ngTemplateOutlet="runs; context: { $implicit: block.inlines }"></ng-container></h2> }
        @case (3) { <h3 class="md-heading md-h3"><ng-container *ngTemplateOutlet="runs; context: { $implicit: block.inlines }"></ng-container></h3> }
        @default  { <h4 class="md-heading md-h4"><ng-container *ngTemplateOutlet="runs; context: { $implicit: block.inlines }"></ng-container></h4> }
      }
    }

    @if (block.kind === 'paragraph') {
      <p class="md-paragraph">
        <ng-container *ngTemplateOutlet="runs; context: { $implicit: block.inlines }"></ng-container>
      </p>
    }

    @if (block.kind === 'list') {
      <div class="md-list" [attr.role]="'list'">
        @for (item of block.items; track $index) {
          <div class="md-list-item" [style.margin-left]="indentFor(item)" role="listitem">
            <span class="md-marker" aria-hidden="true">{{ item.marker }}</span>
            <span class="md-item-body">
              <ng-container *ngTemplateOutlet="runs; context: { $implicit: item.inlines }"></ng-container>
            </span>
          </div>
        }
      </div>
    }

  }
</div>

<!--
  One run of inline text. Emphasis is carried as flags rather than nested elements, so bold and
  italic combine without the template having to recurse.
-->
<ng-template #runs let-inlines>
  @for (run of inlines; track $index) {
    @if (run.href) {
      <a class="md-link"
         [attr.href]="run.href"
         target="_blank"
         rel="noopener noreferrer"
         [class.md-bold]="run.bold"
         [class.md-italic]="run.italic">{{ run.text }}</a>
    } @else {
      <span [class.md-bold]="run.bold" [class.md-italic]="run.italic">{{ run.text }}</span>
    }
  }
</ng-template>
